<script>

import {Bar} from 'vue-chartjs';

export default {
  extends: Bar,
  props: ['datasets', 'labels'],
  methods: {
    handle(point, event) {
      // this.datasets[item._datasetIndex] In this object we can store the id of the user
      // item._index = If we create perfect year arrays this is the (month_number - 1)
      // we can emit events for show the queries for a given user in a given month
      const item = event[0];
      if (item) {
        this.$emit('on-receive', {
          index: item._index,
          backgroundColor: item._view.backgroundColor,
          value: this.datasets[item._datasetIndex],
        });
      }
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handle,
        legend: {
          display: false
        }
      },
    };
  },
  mounted() {
    this.renderChart({
        labels: this.labels,
      datasets: this.datasets,
    }, this.options);
  },
};
</script>
